export const parseBoolean = (value) => {
  if (typeof value === "boolean") return value;

  return value?.toString().toLowerCase() === "true";
};
